import classNames from 'classnames'
import { CategoryCardOverlayLink } from '~/components/CategoryCardOverlayLink'

import styles from './BrandCategoryCard.module.scss'
import { BrandCategoryCardProps } from './BrandCategoryCard.types'

export const BrandCategoryCard = ({
  image,
  title,
  action,
  isDesktopCarouselDisabled,
  categorySku,
  width,
}: BrandCategoryCardProps) => {
  return (
    <div
      className={classNames(
        styles.card,
        width === 'super-narrow' && styles.superNarrowCard,
        isDesktopCarouselDisabled && styles.desktopCarouselDisabledCard,
        'py-2 px-10 relative overflow-hidden'
      )}>
      <CategoryCardOverlayLink
        url={action?.url}
        sku={categorySku}
        title={title}
      />
      <div
        className={classNames(
          styles.cardImage,
          'relative rounded-md',
          'bg-contain bg-center bg-no-repeat'
        )}
        style={{
          backgroundImage: `url(${image.src})`,
        }}
      />
    </div>
  )
}
